import React, { useCallback, FC } from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { NavigationItemMenuModel, PrimaryLinkModel } from '../models/navigationItem.model';
import MenuLink from './subMenuElement/menuLink';
import NavigationItemMenuStructure from './navigationItemMenuStructure';
import { useMenuDispatcher } from './menuContext';
import { googleNavClickEvent } from '../../../utils/analytics';
import { topMainMenu } from '../../../constants/analytics.constants';

export const NavigationItemTray: FC<{
  model: NavigationItemMenuModel;
  onClick?: () => void;
  closeMainNavigation?: () => void;
  isOpen?: boolean;
}> = ({ model, closeMainNavigation, isOpen }) => {
  const menuDispatcher = useMenuDispatcher();
  const handleLinkClick = useCallback(() => {
    menuDispatcher({ type: 'closeAll' });
    if (closeMainNavigation) closeMainNavigation(); // this is undefined in desktop
  }, [closeMainNavigation, menuDispatcher]);
  return (
    <div
      className={`navigation-item__tray navigation-item__tray--full-width ${
        isOpen ? 'navigation-item__tray--open' : 'navigation-item__tray--close'
      }`}
    >
      {model.columns.map((columnModel) => {
        return (
          <div className={'navigation__custom-column'} key={columnModel?.id}>
            {columnModel.elements
              .filter((elementFilter: PrimaryLinkModel) => elementFilter.linkUrl !== '')
              .map((elementModel, j) => (
                <MenuLink model={elementModel} key={j} onClick={handleLinkClick} />
              ))}
          </div>
        );
      })}
    </div>
  );
};

const NavigationItemMenu = ({ model }: { model: NavigationItemMenuModel }) => {
  return (
    <NavigationItemMenuStructure
      onclick={() => {
        googleNavClickEvent(topMainMenu, '#', model?.displayName);
      }}
      triggerContent={<RichText tag="div" field={model.menuTitle} className="navigation__menu-item__trigger__content rich-text" />}
    >
      <NavigationItemTray model={model} />
    </NavigationItemMenuStructure>
  );
};

export default NavigationItemMenu;
